import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ComponentsModule} from '../../../components/components.module';
import {ButtonModule} from 'primeng/button';
import {ToastModule} from 'primeng/toast';
import {MaintenanceComponent} from './maintenance.component';
import {TooltipModule} from "primeng/tooltip";

@NgModule({
    declarations: [MaintenanceComponent],
    imports: [CommonModule, ComponentsModule, ButtonModule, ToastModule, TooltipModule],
    exports: [MaintenanceComponent],
})
export class MaintenanceModule {}
